import { useLocation } from 'react-router';

import { ButtonProps, ButtonSizes, ButtonVariant, LinkAsButton, Typography } from '@/shared/ui';

import { ROUTES } from '@/router/config';

interface Props {
  className?: string;
  onClick?: () => void;
  isResponsive?: ButtonProps['isResponsive'];
  shorten?: boolean;
  size?: ButtonProps['size'];
}

export const OrderServiceLink: React.FC<Props> = ({
  className = '',
  onClick,
  shorten,
  isResponsive = false,
  size = ButtonSizes.MD,
}) => {
  const { search } = useLocation();

  return (
    <LinkAsButton
      variant={ButtonVariant.CONTRAST}
      className={className}
      onClick={onClick}
      isResponsive={isResponsive}
      to={`${ROUTES.INTERNAL_SERVICES}${search ?? ''}`}
      size={size}
    >
      <Typography as="span" className="header-banner__order-service-btn">
        Замовити {shorten ? '' : 'послугу'}
      </Typography>
    </LinkAsButton>
  );
};
